"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObservableEntity = void 0;
const ObserverList_1 = require("./ObserverList");
class ObservableEntity {
    constructor() {
        this.observerList = new ObserverList_1.ObserverList();
        this.addObserver = (observer) => {
            this.observerList.add(observer);
        };
        this.removeObserver = (observer) => {
            this.observerList.remove(observer);
        };
        this.notify = () => {
            this.observerList.notify();
        };
    }
}
exports.ObservableEntity = ObservableEntity;
